import { render, staticRenderFns } from "./BusinessStartupPageInternalProjectDetails.vue?vue&type=template&id=1229aa3d&"
import script from "./BusinessStartupPageInternalProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./BusinessStartupPageInternalProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1229aa3d')) {
      api.createRecord('1229aa3d', component.options)
    } else {
      api.reload('1229aa3d', component.options)
    }
    module.hot.accept("./BusinessStartupPageInternalProjectDetails.vue?vue&type=template&id=1229aa3d&", function () {
      api.rerender('1229aa3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/internal-projects/BusinessStartupPageInternalProjectDetails.vue"
export default component.exports